import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({name: 'seconds'})

export class SecondsPipe implements PipeTransform {

	constructor(
		private translate: TranslateService) {
	}

	transform(seconds: number, format?: 'withFrames' | 'withMiliseconds' | 'long' | '', milliseconds = false, kpi = false): string {
		if (format === 'withFrames') {
			return this.withFrames(seconds);
		}
		if (format === 'withMiliseconds') {
			return this.withMiliSeconds(seconds);
		}

		if (milliseconds) {
			seconds = seconds / 1000;
		}

		seconds = Math.round(seconds);

		if (typeof seconds !== 'undefined' && isFinite(seconds)) {

			let years: number = Math.floor(seconds / 31556952);
			let days: number = Math.floor(seconds / 86400) - (years * 365);
			let hours: number = Math.floor(seconds / 3600) - (Math.floor(seconds / 86400) * 24);
			let minutes: number = Math.floor(seconds / 60) - (Math.floor(seconds / 3600) * 60);
			seconds = seconds - (Math.floor(seconds / 60) * 60);

			if (typeof years === 'undefined') {
				years = 0;
			}
			if (typeof days === 'undefined') {
				days = 0;
			}
			if (typeof minutes === 'undefined') {
				minutes = 0;
			}
			if (typeof hours === 'undefined') {
				hours = 0;
			}
			if (typeof seconds === 'undefined') {
				seconds = 0;
			}

			if (format === 'long') {
				// Yo dawg...
				if (years) {
					return years + ' ' + this.translate.instant('YEARS') + ' ' +
						days + ' ' + this.translate.instant('DAYS') + ' ' +
						hours + ' ' +  this.translate.instant('HOURS') + ' ' +
						minutes + ' ' +  this.translate.instant('MINUTES') + ' ' +
						seconds + ' ' +  this.translate.instant('SECONDS');
				}
				if (days) {
					return days + ' ' + this.translate.instant('DAYS') + ' ' +
						hours + ' ' +  this.translate.instant('HOURS') + ' ' +
						minutes + ' ' +  this.translate.instant('MINUTES') + ' ' +
						seconds + ' ' +  this.translate.instant('SECONDS');
				}
				if (hours) {
					return hours + ' ' +  this.translate.instant('HOURS') + ' ' +
						minutes + ' ' +  this.translate.instant('MINUTES') + ' ' +
						seconds + ' ' +  this.translate.instant('SECONDS');
				}
				if (minutes) {
					return minutes + ' ' +  this.translate.instant('MINUTES') + ' ' +
						seconds + ' ' +  this.translate.instant('SECONDS');
				}
				if (seconds) {
					return seconds + ' ' +  this.translate.instant('SECONDS');
				}
			} else if (kpi) {
				if (years) {
					const afterComma = this.afterComma(years);
					const daysRemainPercentage = String(days / 365 * 10).replace(/[^0-9|-]/g, '');
					if (afterComma === 2) {
						return (years + '.' + ((daysRemainPercentage) + '').slice(0, 2) + 'y');
					} else if (afterComma === 1) {
						return (years + '.' + ((daysRemainPercentage) + '').slice(0, 1) + 'y');
					} else {
						return (years + 'y');
					}
				}
				if (days) {
					const afterComma = this.afterComma(days);
					const hoursRemainPercentage = String(hours / 24 * 10).replace(/[^0-9|-]/g, '');
					if (afterComma === 2) {
						return (days + '.' + ((hoursRemainPercentage) + '').slice(0, 2) + 'd');
					} else if (afterComma === 1) {
						return (days + '.' + ((hoursRemainPercentage) + '').slice(0, 1) + 'd');
					} else {
						return (days + 'd');
					}
				}
				if (hours) {
					const afterComma = this.afterComma(hours);
					const minutesRemainPercentage = String(minutes / 60 * 10).replace(/[^0-9|-]/g, '');
					if (afterComma === 2) {
						return (hours + '.' + ((minutesRemainPercentage) + '').slice(0, 2) + 'h');
					} else if (afterComma === 1) {
						return (hours + '.' + ((minutesRemainPercentage) + '').slice(0, 1) + 'h');
					} else {
						return (hours + 'h');
					}
				}
				if (minutes) {
					const afterComma = this.afterComma(minutes);
					const secondsRemainPercentage = String(seconds / 60 * 10).replace(/[^0-9|-]/g, '');
					if (afterComma === 2) {
						return (minutes + '.' + ((secondsRemainPercentage) + '').slice(0, 2) + 'm');
					} else if (afterComma === 1) {
						return (minutes + '.' + ((secondsRemainPercentage) + '').slice(0, 1) + 'm');
					} else {
						return (minutes + 'm');
					}
				}
				return seconds + 's';
			} else {
				if (hours > 0) {
					return (1e15 + (hours) + '').slice(-2) + ':' + (1e15 + (minutes) + '').slice(-2) + ':' + (1e15 + (seconds) + '').slice(-2);
				}
				return (1e15 + (minutes) + '').slice(-2) + ':' + (1e15 + (seconds) + '').slice(-2);
			}
		}
		// return 'seconds ' + seconds;
	}

	afterComma(value) {
		const rest = String(value).length % 3;
		let afterComma = rest; // max
		if (rest === 2 ) {
			afterComma = 1;
		} else if (rest === 1 ) {
			afterComma = 2;
		}
		return afterComma;
	}

	withFrames(time: number): string {
		if (time < 0) {
			return '00:00:00.00';
		}

		const remainder = time - Math.floor(time);
		let timeDisplay = this.getBaseTime(time);

		const frames = (remainder * 25).toFixed();
		timeDisplay += ('0' + frames).slice(-2);

		return timeDisplay;
	}

	withMiliSeconds(time: number): string {
		if (!time || time < 0) {
			return '00:00.00';
		}

		const remainder = time - Math.floor(time);
		let timeDisplay = this.getBaseTime(time);

		const milliseconds: string = Math.round(remainder * 100).toFixed();
		timeDisplay += ('0' + milliseconds).slice(-2);

		return timeDisplay;
	}

	// returns rounded seconds part before timeFrames/miliseconds
	getBaseTime(time: number): string {
		let timeDisplay = '';
		time = Math.floor(time);

		const hour: number = Math.floor( time / 3600 );
		if (hour) {
			timeDisplay += ('0' + hour).slice(-2) + ':';
		}

		time -= hour * 3600;

		const minute: number = Math.floor( time / 60 );
		timeDisplay += ('0' + minute).slice(-2) + ':';

		time -= minute * 60;

		timeDisplay += ('0' + time).slice(-2) + '.';
		return timeDisplay;
	}
}
